var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"a-container"},[_c('div',{staticClass:"blog-cpc-cards"},[_c('h3',{staticClass:"title"},[_vm._v("\n            "+_vm._s(_vm.title)+"\n        ")]),_vm._v(" "),_c('blog-cpc-list',{staticClass:"list",attrs:{"cards":_vm.cards,"is-loading":_vm.isLoading}}),_vm._v(" "),_vm._t("pagination")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }